const DEFAULT_TELEGRAM_GROUP_URL = 'https://t.me/+BGuUnb57hLxiZDk1';
const DEFAULT_TELEGRAM_TEST_GROUP_URL = 'https://t.me/+l5do5CMKEltjMmU1';
const DEFAULT_TELEGRAM_BOT_USERNAME = 'TCASIWBot';

const isTrue = (value) => String(value).trim().toLowerCase() === 'true';

export const TELEGRAM_CTA_URL = isTrue(process.env.REACT_APP_USE_TEST_TELEGRAM_GROUP)
  ? process.env.REACT_APP_TELEGRAM_TEST_GROUP_URL || DEFAULT_TELEGRAM_TEST_GROUP_URL
  : process.env.REACT_APP_TELEGRAM_GROUP_URL || DEFAULT_TELEGRAM_GROUP_URL;

const TELEGRAM_BOT_USERNAME = process.env.REACT_APP_TELEGRAM_BOT_USERNAME || DEFAULT_TELEGRAM_BOT_USERNAME;

export const getTelegramDeepLink = (resultId) => {
  return `https://t.me/${TELEGRAM_BOT_USERNAME}?start=onboard_${resultId}`;
};

export const openTelegramCta = () => {
  if (typeof window === 'undefined') {
    return;
  }

  window.open(TELEGRAM_CTA_URL, '_blank', 'noopener,noreferrer');
};
